import { splitTextIntoFields } from "./textFieldExtractor";

const READING_ORDER_ROW_THRESHOLD = 18;

/** @param {Array<{ text: string, confidence: number, bbox: number[] }>} lines */
export function sortLinesReadingOrder(lines) {
  return [...lines].sort((a, b) => {
    const ay = (a.bbox[1] + a.bbox[3]) / 2;
    const by = (b.bbox[1] + b.bbox[3]) / 2;
    if (Math.abs(ay - by) > READING_ORDER_ROW_THRESHOLD) {
      return ay - by;
    }
    return a.bbox[0] - b.bbox[0];
  });
}

/** @param {Array<{ text: string, confidence: number, bbox: number[] }>} lines */
export function linesToRawText(lines) {
  return sortLinesReadingOrder(lines)
    .map((line) => line.text.trim())
    .filter(Boolean)
    .join("\n");
}

/** @param {Array<{ text: string, confidence: number, bbox: number[] }>} lines */
export function linesToStructuredFields(lines) {
  const rawText = linesToRawText(lines);
  if (!rawText.trim()) return [];

  const fromLabels = splitTextIntoFields(rawText);
  if (fromLabels.length) return fromLabels;

  return sortLinesReadingOrder(lines).map((line, index) => ({
    label: `Line ${index + 1}`,
    value: line.text,
    confidence: line.confidence,
  }));
}

/** @param {Array<{ text: string, confidence: number, bbox: number[] }>} lines */
export function averageLineConfidence(lines) {
  if (!lines.length) return 0;
  return lines.reduce((sum, line) => sum + line.confidence, 0) / lines.length;
}
